import { render } from "./inbox.svg?vue&type=template&id=11b6e1be"
const script = {}
script.render = render

export default script